"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function onSuccess(actionContext, _ref) {
  var response = _ref.response;
  actionContext.dispatch('SET_SETTINGS', response.data);
}
var _default = function _default(config) {
  return {
    serviceName: 'retrieveSettings',
    authenticate: true,
    config: {
      method: 'GET',
      url: (0, _get.default)(config, 'endpoints.prompt.settings.retrieve')
    },
    onSuccess: onSuccess
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(onSuccess, "onSuccess", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/settings/retrieve-settings.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/settings/retrieve-settings.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJvblN1Y2Nlc3MiLCJhY3Rpb25Db250ZXh0IiwicmVzcG9uc2UiLCJkaXNwYXRjaCIsImRhdGEiLCJjb25maWciLCJzZXJ2aWNlTmFtZSIsImF1dGhlbnRpY2F0ZSIsIm1ldGhvZCIsInVybCIsImdldCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZXJ2aWNlcy9zZXJ2aWNlLWNvbmZpZ3Mvc2V0dGluZ3MvcmV0cmlldmUtc2V0dGluZ3MuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdldCBmcm9tICdsb2Rhc2gvZ2V0JztcblxuZnVuY3Rpb24gb25TdWNjZXNzKGFjdGlvbkNvbnRleHQsIHsgcmVzcG9uc2UgfSkge1xuXHRhY3Rpb25Db250ZXh0LmRpc3BhdGNoKCdTRVRfU0VUVElOR1MnLCByZXNwb25zZS5kYXRhKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgKGNvbmZpZykgPT4gKHtcblx0c2VydmljZU5hbWU6ICdyZXRyaWV2ZVNldHRpbmdzJyxcblx0YXV0aGVudGljYXRlOiB0cnVlLFxuXHRjb25maWc6IHtcblx0XHRtZXRob2Q6ICdHRVQnLFxuXHRcdHVybDogZ2V0KGNvbmZpZywgJ2VuZHBvaW50cy5wcm9tcHQuc2V0dGluZ3MucmV0cmlldmUnKSxcblx0fSxcblx0b25TdWNjZXNzLFxufSk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUE2QjtFQUFBO0VBQUE7QUFBQTtBQUFBO0VBQUE7QUFBQTtBQUU3QixTQUFTQSxTQUFTLENBQUNDLGFBQWEsUUFBZ0I7RUFBQSxJQUFaQyxRQUFRLFFBQVJBLFFBQVE7RUFDM0NELGFBQWEsQ0FBQ0UsUUFBUSxDQUFDLGNBQWMsRUFBRUQsUUFBUSxDQUFDRSxJQUFJLENBQUM7QUFDdEQ7QUFBQyxlQUVjLGtCQUFDQyxNQUFNO0VBQUEsT0FBTTtJQUMzQkMsV0FBVyxFQUFFLGtCQUFrQjtJQUMvQkMsWUFBWSxFQUFFLElBQUk7SUFDbEJGLE1BQU0sRUFBRTtNQUNQRyxNQUFNLEVBQUUsS0FBSztNQUNiQyxHQUFHLEVBQUUsSUFBQUMsWUFBRyxFQUFDTCxNQUFNLEVBQUUsb0NBQW9DO0lBQ3RELENBQUM7SUFDREwsU0FBUyxFQUFUQTtFQUNELENBQUM7QUFBQSxDQUFDO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQVpPQSxTQUFTO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==